import { render, staticRenderFns } from "./karlilikraporu.vue?vue&type=template&id=f8a59ea2&"
import script from "./karlilikraporu.vue?vue&type=script&lang=js&"
export * from "./karlilikraporu.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports